export default __webpack_public_path__ + "static/soanpapri-9e0313d7e8316bc7e5aec327dcbdccb4.png";